import { createFileRoute } from '@tanstack/react-router';
import { FullPageConsole } from '../components/range/FullPageConsole';

/**
 * Full-screen console route (ludus2-style). Reached from the admin range page
 * and the trainee workstation view. Keyed on rangeId:vmName so switching VMs
 * remounts cleanly (fresh token + iframe).
 */
export const Route = createFileRoute('/console/$rangeId/$vmName')({
  // `returnTo` remembers where the console was opened from (e.g. /labs/<id>)
  // so Back returns there instead of relying on browser history, which the
  // Guacamole iframe pollutes.
  validateSearch: (search: Record<string, unknown>): { returnTo?: string } =>
    typeof search.returnTo === 'string' ? { returnTo: search.returnTo } : {},
  component: ConsoleScreen,
});

export function ConsoleScreen() {
  const { rangeId, vmName } = Route.useParams();
  const { returnTo } = Route.useSearch();
  return (
    <FullPageConsole
      key={`${rangeId}:${vmName}`}
      rangeId={rangeId}
      vmName={vmName}
      {...(returnTo ? { returnTo } : {})}
    />
  );
}
